export const runtimeMappings = {
  currentDate: {
    type: 'long',
    script: `
      long currentDate = (long)(new Date().getTime() * 1000000);
      emit(currentDate);
    `,
  },
  shortRegion: {
    type: 'keyword',
    script: `
      String region = params['_source']['region'];

      Pattern regexp1 = /[0-9\\/\\.!@#$%^&*,]+/;
      Pattern regexp2 = /\\s{2,}/;
      Pattern regexp3 = /,/;

      String tempString1 = regexp1.matcher(region).replaceAll(' ').trim();
      String tempString2 = regexp2.matcher(tempString1).replaceAll(',');
      String[] arr = regexp3.split(tempString2);

      String country = arr[arr.length - 1];
      emit(country);
    `,
  },
  parsedSquare: {
    type: 'double',
    script: {
      lang: 'painless',
      source: `
        double sq = Double.parseDouble(params['_source']['square']);
        emit(sq);
      `,
    },
  },
  isStagesFinished: {
    type: 'boolean',
    script: `
      boolean isStagesFinished = false;
      def stages = params['_source']['stages'];
      if (stages !== null) {
        long currentDate = doc['currentDate'].value;
        def lastStage = stages[stages.length - 1];
        long endTime = Long.parseLong(lastStage.ends_at);
        if (currentDate > endTime) {
          isStagesFinished = true;
        }
      }
      emit(isStagesFinished);
    `,
  },
  isCarbonProject: {
    type: 'boolean',
    script: `
      boolean isCarbonProject = false;
      def leakage = params['_source']['leakage'];
      if (leakage !== null) {
        isCarbonProject = Boolean.parseBoolean(String.valueOf(leakage.carbonApprove));
      }
      emit(isCarbonProject);
    `,
  },
  currentStage: {
    type: 'long',
    script: {
      lang: 'painless',
      source: `
        long res = -1;
        String projectStatus = params['_source']['status'];
        boolean isStagesFinished = doc['isStagesFinished'].value;
        if (projectStatus === 'register' || isStagesFinished) {
          emit(res);
          return;
        }
  
        def stages = params['_source']['stages'];
        if (stages === null) {
          emit(res);
          return;
        }
    
        long currentDate = doc['currentDate'].value;
        for (int i = 0; i < stages.length; i++){
          long startStage = Long.parseLong(stages[i]['starts_at']);
          long endStage = Long.parseLong(stages[i]['ends_at']);
          if (currentDate >= startStage && currentDate <= endStage) {
            res = (long)(i);
            break;
          }
        }
        emit(res);
      `,
    },
  },
  currentVotingStage: {
    type: 'long',
    script: `
      long currentDate = doc['currentDate'].value;
      long currentStage = doc['currentStage'].value;
      def stages = params['_source']['stages'];
      long currentVotingStage = -1;

      if (stages === null) {
        emit(currentVotingStage);
        return;
      }
      if (currentStage === -1) {
        def lastStage = stages[stages.length - 1];
        long stageEnd = Long.parseLong(lastStage.ends_at);
        def lastStagePeriods = lastStage.periods;
        def lastPeriod = lastStagePeriods[lastStagePeriods.length - 1];
        long endPeriod = Long.parseLong(lastPeriod.ends_at);
        if (stageEnd <= currentDate && currentDate <= endPeriod) {
          currentVotingStage = stages.length - 1;
        }
        emit(currentVotingStage);
        return;
      }
      if (currentStage >= 0) {
        currentVotingStage = currentStage - 1;
        emit(currentVotingStage);
        return;
      }
    `,
  },
  currentPeriod: {
    type: 'long',
    script: `
      long currentPeriod = -1;
      long currentDate = doc['currentDate'].value;
      int currentVotingStageId = (int)doc['currentVotingStage'].value;
      if (currentVotingStageId >= 0) {
        def currentVotingStage = params['_source']['stages'][currentVotingStageId];
        def periods = currentVotingStage.periods;
        for (int i = 0; i < periods.length; i++) {
          long startPeriod = Long.parseLong(periods[i]['starts_at']);
          long endPeriod = Long.parseLong(periods[i]['ends_at']);
          if (currentDate >= startPeriod && currentDate <= endPeriod) {
            currentPeriod = (long)(i);
            break;
          }
        }
      }
      emit(currentPeriod);
    `,
  },
  deadline: {
    type: 'long',
    script: {
      lang: 'painless',
      source: `
        int stageId = (int)(doc['currentStage'].value);
        long currentDate = doc['currentDate'].value;
        if (stageId >= 0) {
          emit(Long.parseLong(params['_source']['stages'][stageId]['ends_at']) - currentDate);
        } else {
          emit(0);
        }
      `,
    },
  },
  isLastValidationBegins: {
    type: 'boolean',
    script: `
      boolean isLastValidationBegins = false;
      def stages = params['_source']['stages'];
      if (stages !== null) {
        long currentDate = doc['currentDate'].value;
        def lastValidation = stages[stages.length - 1].periods[0];
        long lastValidationStart = Long.parseLong(lastValidation.starts_at);
        if (currentDate < lastValidationStart) {
          isLastValidationBegins = false;
        } else {
          isLastValidationBegins = true;
        }
      }
      emit(isLastValidationBegins);
    `,
  },
};

export const getMapping = (value) => value[0];
